module.exports = __webpack_public_path__ + "static/media/UpcomingServices.b5fe27aa.png";